import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonFunctions } from '../../static/common-functions';
import { DispatchData } from '../../models/DispatchData';
import { WindowComponent } from '@progress/kendo-angular-dialog';
import { DQOIItem } from '../../models/DQOIItem';
import { DQOIService } from '../../services/DQOI.service';

@Component({
    selector: 'dqoi-in-window',
    templateUrl: './dqoi-in-window.component.html',
    styleUrls: ['./dqoi-in-window.component.scss']
})
export class DQOIInWindowComponent {

  constructor(private svc_dqoi: DQOIService) { }
    @ViewChild('kWindow') protected kWindow: WindowComponent;

    dispatchData: DispatchData;
    @Input() set data(value: DispatchData) {
        if (CommonFunctions.hasValue(value)) {
            this.dispatchData = value;
            this.active = true;
        }
     }
    
    @Input() set title(value: string) {
        if (CommonFunctions.hasStringValue(value)) {
            this.windowTitle = value;
        }
    }
    windowTitle: string = "";
    active: boolean = false;
	@Output() closed = new EventEmitter<any>(); 

    dqoiIndex: number = null;
    DQOIEvent(index: number) {
        this.dqoiIndex = index;
    }
    closeWindow() {
        this.svc_dqoi.clearDQOIItem(this.dqoiIndex);
        this.dqoiIndex = null;
        this.active = false;
		this.closed.emit(true);
    }
    public windowTop: number = 0;
    public windowLeft: number = 0;
}
